<template>
  <div class="jsc-bg">
    <div class="top">
      <div class="sys-date">{{ today }}</div>
      <div class="sys-title">场馆预约驾驶舱</div>
      <div class="sys-temp"><div id="he-plugin-simple"></div></div>
    </div>
    <div>
      <my-scale @changeSize="changeSize">
        <div
          :style="{
            'margin-top': 'calc(' + mySize + 'vw' + ' + 16px',
          }"
          class="d-column d-center d-allcenter"
          style="width: 1920px"
        >
          <div class="order-top d-aligncnter">
            <div class="order-left d-column">
              <div class="left-top">
                <div class="d-aligncnter" style="font-size: 20px">
                  <img src="@/assets/img/venuesorder/dashboard-one.svg" style="margin-right: 8px" /><span
                    >累计预约人次</span
                  >
                </div>
                <div class="nums-box d-allcenter">
                  <div
                    class="allNum d-allcenter"
                    v-for="(item, index) in String(totalData.total).length"
                    :key="'num_' + index"
                  >
                    {{ String(totalData.total)[index] }}
                  </div>
                  <div class="d-allcenter" style="color: #007a4d; font-size: 14px; height: 48px">人</div>
                </div>
                <div class="d-allcenter line-div">
                  <img src="@/assets/img/venuesorder/line.svg" />
                </div>
                <div class="d-aligncnter d-center d-around" style="font-size: 18px">
                  <div class="d-column d-aligncnter" style="width: 45%">
                    <div>今日预约</div>
                    <div class="box-one-font">{{ totalData.jryy }}</div>
                  </div>
                  <div style="color: #007a4d; margin-top: 22px" v-if="totalData.jryy == totalData.jrrc">=</div>
                  <div
                    style="color: #007a4d; margin-top: 22px"
                    v-else
                    v-text="totalData.jryy > totalData.jrrc ? '>' : '<'"
                  ></div>
                  <div class="d-column d-aligncnter" style="width: 45%">
                    <div>今日进场</div>
                    <div class="box-one-font">{{ totalData.jrrc }}</div>
                  </div>
                </div>
                <div class="d-allcenter line-div">
                  <img src="@/assets/img/venuesorder/line.svg" />
                </div>
                <div class="d-aligncnter d-center d-around" style="font-size: 18px">
                  <div class="d-column d-aligncnter" style="width: 45%">
                    <div>昨日预约</div>
                    <div class="box-one-font">{{ totalData.zryy }}</div>
                  </div>

                  <div style="color: #007a4d; margin-top: 22px" v-if="totalData.zryy == totalData.zrrc">=</div>
                  <div
                    style="color: #007a4d; margin-top: 22px"
                    v-else
                    v-text="totalData.zryy > totalData.zrrc ? '>' : '<'"
                  ></div>
                  <div class="d-column d-aligncnter" style="width: 45%">
                    <div>昨日进场</div>
                    <div class="box-one-font">{{ totalData.zrrc }}</div>
                  </div>
                </div>
              </div>
              <div class="left-bottom">
                <div class="d-aligncnter" style="font-size: 20px; margin-bottom: 8px">
                  <img src="@/assets/img/venuesorder/data-one.svg" style="margin-right: 8px" /><span
                    >各场馆累计预约数据</span
                  >
                </div>
                <div style="border-radius: 4px; overflow: hidden">
                  <table class="left-table" cellspacing="0">
                    <tr class="t-head">
                      <td class="td-1">场馆</td>
                      <td class="td-2">预约</td>
                      <td class="td-3">入场</td>
                    </tr>
                  </table>
                  <div style="overflow: hidden; height: 300px" @mouseenter="stopScrollOne" @mouseleave="startScrollOne">
                    <table
                      class="left-table"
                      cellspacing="0"
                      :class="{ 'animated-top': animatedTop && allAppointmentsList.length > 9 }"
                    >
                      <tr
                        class="tr-data"
                        v-for="(item, index) in allAppointmentsList"
                        :key="'allData_' + index"
                        :class="index % 2 == 1 ? 'color-tr' : ''"
                      >
                        <td class="college-name td-1 overflow">{{ item.name }}</td>
                        <td class="td-2">{{ item.yycs }}</td>
                        <td class="td-3">
                          <el-progress
                            :percentage="item.rate"
                            :show-text="false"
                            color="#007A4D"
                            define-back-color="#FFB612"
                          ></el-progress>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="order-center d-column">
              <div class="d-aligncnter">
                <div class="d-allcenter" :style="{ width: 'calc(50% - 12px *' + discrib.name.length + ')' }">
                  <img src="@/assets/img/venuesorder/linethree.svg" style="width: 100%" />
                </div>
                <div class="venues-name" :style="{ width: 'calc(24px *' + discrib.name.length + ')' }">
                  {{ discrib.name }}
                </div>
                <div class="d-allcenter" :style="{ width: 'calc(50% - 12px *' + discrib.name.length + ')' }">
                  <img src="@/assets/img/venuesorder/linethree.svg" style="width: 100%" />
                </div>
              </div>
              <div class="d-start" style="margin-top: 16px">
                <div style="width: 287px; height: 192px">
                  <img :src="discrib.img" style="width: 100%; height: 100%" />
                </div>
                <div class="describe">
                  <div v-html="discrib.profile"></div>
                  <!-- <div>学校教学日历安排向本校师生员工、免费开放，部分场馆经预约后向社会免费开放。</div>
                  <div>校外人员须先支付费用后进入场馆，校友费用优惠，费用由学校统一收取。</div>
                  <div>人员预约后提前15分钟可进场，结束时间到后不能再进场，期间出入不做限制。</div>
                  <div>退费需要提前8小时，否则无法退费。</div>
                  <div>
                    校内单位可免费使用体育场馆，大型活动原则上提前十个工作日提出申请，一般活动原则上提前五个工作日提出申请。
                  </div>
                  <div>校外大型活动原则上提前一个月预约，一般活动原则上提前十个工作日预约。</div>
                  <div>黑名单制度6个月内不得进入体育场馆。6 个月后提出申请恢复进入。</div> -->
                </div>
              </div>
              <div class="d-aligncnter select-option">
                <div style="width: 36px; height: 36px; cursor: pointer" class="d-allcenter" @click="leftDayClick">
                  <img src="@/assets/img/venuesorder/btn-left.svg" style="width: 100%" />
                </div>
                <el-date-picker
                  v-model="orderDate"
                  type="date"
                  placeholder="选择日期"
                  style="margin: 0 8px"
                  :style="{ width: 'calc(516px - 48px *' + tabsList.length + ')' }"
                  :clearable="false"
                  @change="changeDate"
                >
                </el-date-picker>
                <div
                  style="width: 36px; height: 36px; cursor: pointer; margin-right: 8px"
                  class="d-allcenter"
                  @click="rightDayClick"
                >
                  <img src="@/assets/img/venuesorder/btn-right.svg" style="width: 100%" />
                </div>
                <div
                  class="items-tab d-allcenter"
                  v-for="(item, index) in tabsList"
                  :key="'cd_' + index"
                  :class="tabsIndex == index ? 'tab-curr' : ''"
                  @click="tabClicks(item, index)"
                >
                  {{ item.areaName }}
                </div>
                <!-- <div class="items-tab"></div>tabsIndex = index
                <div class="items-tab"></div>
                <div class="items-tab"></div> -->
                <div
                  style="height: 36px; margin-left: 8px"
                  class="d-allcenter"
                  :style="{ width: 'calc(524px - 48px *' + tabsList.length + ')' }"
                >
                  <el-input v-model="inputData" placeholder="查找预约信息"></el-input>
                </div>
                <div style="width: 68px; height: 36px; margin-left: 4px" class="d-allcenter">
                  <img src="@/assets/img/venuesorder/search.svg" style="width: 100%" />
                </div>
              </div>
              <div
                v-if="areaList.length == 0 || tiemList.length == 0"
                class="d-allcenter d-column"
                style="
                  width: 1216px;
                  height: 370px;
                  border-radius: 4px;
                  border: 1px solid #007a4d;
                  background: #003622;
                  margin-top: 8px;
                "
              >
                <img src="@/assets/img/venuesorder/empty.png" style="width: 344px" />
                <div style="font-size: 18px">暂未开放预约</div>
              </div>
              <div style="margin-top: 8px" class="order-table" v-else>
                <el-table
                  :data="tableData"
                  border
                  style="width: 100%"
                  max-height="370"
                  :cell-style="cellStyle"
                  :header-cell-style="headerCellStyle"
                >
                  <el-table-column fixed label="片场/时间" width="110" align="center">
                    <template slot-scope="scope">
                      <div class="d-allcenter" style="color: #fff">{{ areaList[scope.$index].name }}</div></template
                    >
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="date"
                    :label="item"
                    :width="flexWidth"
                    v-for="(item, index) in tiemList"
                    :key="'time_' + index"
                  >
                    <template slot-scope="scope">
                      <div style="min-height: 42px" :style="{ height: 'calc(320px / ' + areaList.length + ' - 10px)' }">
                        <!-- <div style="min-height: 42px"> -->
                        <!-- <div class="d-allcenter" style="color: #fff; font-size: 14px">
                          {{ tableData[scope.$index][index].eduClass }}
                        </div> -->
                        <div
                          class="d-allcenter"
                          style="color: #fff; font-size: 14px; height: 100%"
                          v-if="!!tableData[scope.$index][index].teacherName"
                        >
                          <!-- {{ tableData[scope.$index][index].teacherName }} -->
                          上课
                        </div>
                        <div
                          class="d-allcenter"
                          style="color: #fff; font-size: 14px; height: 100%"
                          v-else-if="!!tableData[scope.$index][index].eventName"
                        >
                          <!-- {{ tableData[scope.$index][index].eventName }} -->
                          训练
                        </div>
                        <div
                          class="d-allcenter"
                          style="color: #fff; font-size: 14px; height: 100%"
                          v-else-if="!!tableData[scope.$index][index].state"
                        >
                          {{ tableData[scope.$index][index].state }}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="order-right">
              <div class="right-top">
                <div class="d-aligncnter" style="font-size: 20px; margin-bottom: 8px">
                  <img src="@/assets/img/venuesorder/card.svg" style="margin-right: 8px" /><span>预约类型</span>
                </div>
                <div class="d-around" style="font-size: 14px; padding-top: 8px">
                  <div class="d-column d-aligncnter">
                    <el-progress
                      type="circle"
                      :percentage="Number(typeData.student)"
                      :width="64"
                      color="#009AFE"
                      define-back-color="#007A4D4D"
                      text-color="#FFFFFF"
                    ></el-progress>
                    <div class="mt-8">学生</div>
                  </div>
                  <div class="d-column d-aligncnter">
                    <el-progress
                      type="circle"
                      :percentage="Number(typeData.teacher)"
                      :width="64"
                      color="#F97423"
                      define-back-color="#007A4D4D"
                      text-color="#FFFFFF"
                    ></el-progress>
                    <div class="mt-8">教职工</div>
                  </div>
                  <div class="d-column d-aligncnter">
                    <el-progress
                      type="circle"
                      :percentage="Number(typeData.OffCampus)"
                      :width="64"
                      color="#DE3831"
                      define-back-color="#007A4D4D"
                      text-color="#FFFFFF"
                    ></el-progress>
                    <div class="mt-8">校外人员</div>
                  </div>
                </div>
              </div>
              <div class="right-center">
                <div class="d-aligncnter" style="font-size: 20px; margin-bottom: 8px">
                  <img src="@/assets/img/venuesorder/fire.svg" style="margin-right: 8px" /><span>一周预约热度</span>
                </div>
                <!-- <div class="echarts">
                  <div
                    id="order"
                    :style="{
                      width: '228px',
                      height: '140px',
                      margin: '0px auto',
                    }"
                  ></div>
                </div> -->
                <div style="font-size: 12px; height: 80px" class="d-aligncnter d-column">
                  <div class="d-aligncnter d-end" style="height: 60px">
                    <img
                      v-for="(item, index) in popularData"
                      :key="'pop_' + index"
                      src="@/assets/img/venuesorder/bar.png"
                      style="width: 36px; height: 50%"
                      :style="{ height: (Number(item.count) / popularCount) * 100 + '%' }"
                    />
                    <!-- <img src="@/assets/img/venuesorder/bar.png" style="width: 36px; height: 80%" />
                    <img src="@/assets/img/venuesorder/bar.png" style="width: 36px; height: 80%" />
                    <img src="@/assets/img/venuesorder/bar.png" style="width: 36px; height: 60%" />
                    <img src="@/assets/img/venuesorder/bar.png" style="width: 36px; height: 80%" />
                    <img src="@/assets/img/venuesorder/bar.png" style="width: 36px; height: 80%" />
                    <img src="@/assets/img/venuesorder/bar.png" style="width: 36px; height: 100%" /> -->
                  </div>
                  <div class="d-aligncnter" style="height: 100%">
                    <div
                      style="width: 36px; text-align: center"
                      v-for="(item, index) in popularData"
                      :key="'pop2_' + index"
                    >
                      {{ item.week }}
                    </div>
                    <!-- <div style="width: 36px; text-align: center">周二</div>
                    <div style="width: 36px; text-align: center">周三</div>
                    <div style="width: 36px; text-align: center">周四</div>
                    <div style="width: 36px; text-align: center">周五</div>
                    <div style="width: 36px; text-align: center">周六</div>
                    <div style="width: 36px; text-align: center">周日</div> -->
                  </div>
                </div>
              </div>
              <div class="right-bottom">
                <div class="d-aligncnter" style="font-size: 20px; margin-bottom: 8px">
                  <img src="@/assets/img/venuesorder/time.svg" style="margin-right: 8px" /><span>实时入场名单</span>
                </div>

                <div style="border-radius: 4px; overflow: hidden">
                  <div style="overflow: hidden; height: 300px" @mouseenter="stopScrollTwo" @mouseleave="startScrollTwo">
                    <table
                      class="left-table"
                      cellspacing="0"
                      :class="{ 'animated-top': animatedTop2 && this.enterDataList.length > 9 }"
                    >
                      <tr
                        class="tr-data"
                        v-for="(item, index) in enterDataList"
                        :key="'enter_' + index"
                        :class="index % 2 == 1 ? 'color-tr' : ''"
                      >
                        <td class="college-name td-1 overflow">{{ item.cg }}</td>
                        <td class="td-2 overflow">
                          {{ item.xm }}
                        </td>
                        <td class="td-3">{{ item.sj.substr(-8) }}</td>
                      </tr>
                      <!-- <tr class="tr-data color-tr">
                        <td class="college-name td-1 overflow">场馆场馆场馆场馆场馆场馆</td>
                        <td class="td-2 overflow">张*三</td>
                        <td class="td-3">10:31:23</td>
                      </tr> -->
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="venues-list d-allcenter">
            <div style="position: absolute; top: -29px; width: 1872px" class="d-allcenter">
              <img src="@/assets/img/venuesorder/linetwo.svg" />
            </div>
            <div
              style="width: 1640px; height: 174px; overflow: auto; padding: 0 16px"
              class="bottom-box"
              id="scroll-box"
            >
              <!-- <div class="green-div"><div class="green-circle"></div></div> -->
              <div
                class="all-box"
                v-for="(item, index) in allVenuesData"
                :key="'all_' + item.id"
                :class="getCurrBox(item, index)"
                @click="venueClick(item, index)"
              >
                <div v-if="!item.status" class="nums-each"><span class="weight">暂未开放</span></div>
                <div v-else class="nums-each" :class="index == currVenuesIndex ? 'curr-nums-each' : ''">
                  <span class="weight" :class="item.count_sy != item.count ? 'orange' : ''">{{ item.count_sy }}</span
                  >/<span class="weight">{{ item.count }}</span>
                </div>
                <div class="overflow2 name-each">{{ item.name }}</div>
                <div class="enter" @click="pageToEach(item)">进入场馆</div>
              </div>
            </div>
          </div>
        </div>
      </my-scale>
    </div>
  </div>
</template>
<script>
import {
  getAllAppointmentInfo,
  getEachVenueAppointment,
  getPersonnelAppointmentType,
  getAppointmentPopularity,
  getEntrance,
  getEachVenueCapacity,
  getAreas,
  getVenueOrderOpen,
  getVenueProfile,
} from '@/api/api-venueCockpit'
import MyScale from '../components/MyScale.vue'
// import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: '',
  components: {
    MyScale,

    // vueSeamlessScroll,
  },
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      timerOne: null,
      timerTwo: null,
      optionBottom: {},
      optionHeart: {},
      stuList: [],
      currStuIndex: 0,
      classIndex: 0,
      searchKey: '',
      classList: [],

      allNumData: 146888,
      option: {},
      orderDate: '',
      inputData: '',
      tableData: [
        // [
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '《羽毛球2》', tea: '张三', status: 'class' },
        //   { name: '', tea: '', status: '' },
        //   { name: '《羽毛球1》', tea: '张三', status: 'class' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        // ],
        // [
        //   { name: '已预约', tea: '', status: 'order' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '', tea: '', status: '' },
        //   { name: '《乒乓》', tea: '张三', status: 'class' },
        // ],
      ],
      tiemList: ['9:00', '10:00', '11:00', '9:00', '10:00', '11:00', '10:00', '11:00'],
      areaList: [{ name: '', id: '' }],
      allAppointmentsList: [
        { name: '', yycs: '', rccs: '', rate: 0 },
        { name: '', yycs: '', rccs: '', rate: 0 },
      ],
      animatedTop: false,
      animatedTop2: false,
      enterDataList: [
        // { cg: '室内篮球场', xm: '张三', sj: '10:31:23' },
      ],
      currVenuesIndex: 0,
      allVenuesData: [
        // { name: '风雨操场', count_sy: '90', count: '100', status: true },
      ],
      totalData: { total: '0' },
      typeData: {
        student: 0,
        teacher: 0,
        OffCampus: 0,
      },
      popularData: [],
      popularCount: 0,
      tabsIndex: 0,
      tabsList: [{ areaName: '场地1' }, { areaName: '场地2' }],
      discrib: { name: '' },
      showList: false,
      showTotal: false,
      myScrollDiv: {},
    }
  },
  created() {
    let getMyDate = new Date()
    this.orderDate = getMyDate.getTime()
    window.addEventListener('load', this.placeholderPic)
    window.addEventListener('resize', this.placeholderPic)
    // 时间
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 9 ? date.month : '0' + date.month
    let newday = date.date > 9 ? date.date : '0' + date.date
    this.today = date.year + '-' + newmonth + '-' + newday

    this.$nextTick(() => {
      const that = this
      document.addEventListener('DOMContentLoaded', function () {
        // const scrollDiv = document.getElementById('scroll-box')
        that.myScrollDiv = document.getElementById('scroll-box')
        console.log('scrollDiv:', this.myScrollDiv)
        // if (scrollDiv !== null) {
        that.myScrollDiv.addEventListener('wheel', function (e) {
          e.preventDefault()
          that.myScrollDiv.scrollBy({ left: e.deltaY, behavior: 'smooth' })
        })
        // }
      })
    })
  },
  computed: {
    flexWidth() {
      if (this.tiemList.length > 9) {
        return 110
      } else {
        return 1106 / this.tiemList.length
      }
    },
    getCurrBox() {
      return function (item, index) {
        if (index == this.currVenuesIndex) {
          return 'box-curr'
        }
        if (item.status) {
          if (item.count == item.count_sy) {
            return 'box-full'
          } else {
            return 'box-normal'
          }
        } else {
          return 'box-null'
        }
      }
    },
  },
  mounted() {
    // 接口数据
    this.getAllAppointmentInfoData()
    this.getEachVenueAppointmentData()
    this.getPersonnelAppointmentTypeData()
    this.getAppointmentPopularityData()
    this.getEntranceData()
    this.getEachVenueCapacityData()
    this.startScrollOne()
    this.startScrollTwo()

    setInterval(() => {
      this.getAllAppointmentInfoData()
      this.getEachVenueAppointmentData()
      this.getPersonnelAppointmentTypeData()
      this.getAppointmentPopularityData()
      this.getEntranceData()
      this.getEachVenueCapacityData()
    }, 60000)

    // this.drawMonthData()
    // window.onresize = () => {
    //   return (() => {})()
    // }
    window.WIDGET = {
      CONFIG: {
        modules: '02',
        background: '5',
        tmpColor: 'FFFFFF',
        tmpSize: '16',
        cityColor: 'FFFFFF',
        citySize: '16',
        aqiColor: 'FFFFFF',
        aqiSize: '16',
        weatherIconSize: '24',
        alertIconSize: '18',
        padding: '10px 10px 10px 10px',
        shadow: '0',
        language: 'auto',
        fixed: 'false',
        vertical: 'top',
        horizontal: 'left',
        key: '18dcc59e188b4b6684d470c4322bbefa',
      },
    }
    ;(function (d) {
      var c = d.createElement('link')
      c.rel = 'stylesheet'
      c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
      var s = d.createElement('script')
      s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
      var sn = d.getElementsByTagName('script')[0]
      sn.parentNode.insertBefore(c, sn)
      sn.parentNode.insertBefore(s, sn)
    })(document)
  },
  methods: {
    tabClicks(item, index) {
      this.tabsIndex = index
      this.getVenueOrderOpenData()
    },
    stopScrollOne() {
      clearInterval(this.timerOne)
      this.timerOne = null
    },
    startScrollOne() {
      this.timerOne = setInterval(() => {
        if (this.allAppointmentsList.length !== undefined) {
          if (this.allAppointmentsList.length > 9) {
            this.animatedTop = true
            setTimeout(() => {
              this.allAppointmentsList.push(this.allAppointmentsList[0])
              this.allAppointmentsList.shift()
              this.animatedTop = false
            }, 500)
          } else {
            this.stopScrollOne()
          }
        }
      }, 2000)
    },
    stopScrollTwo() {
      clearInterval(this.timerTwo)
      this.timerTwo = null
    },
    startScrollTwo() {
      this.timerTwo = setInterval(() => {
        if (this.enterDataList.length > 9) {
          this.animatedTop2 = true
          setTimeout(() => {
            this.enterDataList.push(this.enterDataList[0])
            this.enterDataList.shift()
            this.animatedTop2 = false
          }, 500)
        } else {
          this.stopScrollTwo()
        }
      }, 2000)
    },
    leftDayClick() {
      console.log('orderDate:', this.orderDate)
      this.orderDate = this.orderDate - 3600 * 1000 * 24
      //   picker.$emit('pick', this.orderDate)
      console.log('orderDate:', this.orderDate)
    },
    rightDayClick() {
      console.log('orderDate:', this.orderDate)
      this.orderDate = this.orderDate + 3600 * 1000 * 24
      //   picker.$emit('pick', this.orderDate)
      console.log('orderDate:', this.orderDate)
    },
    cellStyle({ rowIndex, columnIndex }) {
      //   console.log('row:', row)
      //   console.log('column:', column)
      //   console.log('rowIndex:', rowIndex)
      //   console.log('columnIndex:', columnIndex)
      //   console.log('data:', this.tableData[rowIndex][columnIndex - 1])
      //   console.log('data:', this.tableData[rowIndex][columnIndex - 1].state)
      //   console.log('data:', this.tableData[rowIndex][columnIndex - 1].teacherName)
      //   console.log('data:', this.tableData[rowIndex][columnIndex - 1].eventName)
      if (columnIndex < 1) {
        return 'background: #003622'
      }

      if (this.tableData[rowIndex][columnIndex - 1].teacherName != '') {
        return 'background: #1AA4FE'
      } else if (this.tableData[rowIndex][columnIndex - 1].eventName != '') {
        return 'background: #9419F8'
      } else if (this.tableData[rowIndex][columnIndex - 1].state != '') {
        return 'background: #00A468'
      } else {
        return 'background: #003622'
      }
    },
    headerCellStyle() {
      return 'background: #003622;color:#fff'
    },
    changeCurrRace(item, index) {
      console.log('item:', item)
      this.currIndex = index
    },
    //字体大小
    placeholderPic() {
      const clientWidth = document.documentElement.clientWidth
      const n = 8 * (clientWidth / 380)
      document.documentElement.style.fontSize = n + 'px'
    },
    changeSize(size) {
      console.log('size:', size)
      this.currScale = size
      this.mySize = 5.208 / size
    },
    //接口
    getAllAppointmentInfoData() {
      getAllAppointmentInfo().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res1:', res)
          this.totalData = res.data.obj
          setTimeout(() => {
            this.showTotal = true
          }, 200)
        }
      })
    },
    getEachVenueAppointmentData() {
      getEachVenueAppointment().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res***:', res.data.obj)
          this.allAppointmentsList = res.data.obj
          setTimeout(() => {
            this.showList = true
          }, 200)
        }
      })
    },
    getPersonnelAppointmentTypeData() {
      getPersonnelAppointmentType().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.typeData = res.data.obj
        }
      })
    },
    getAppointmentPopularityData() {
      getAppointmentPopularity().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.popularData = res.data.obj
          let arr = []
          for (let i = 0; i < this.popularData.length; i++) {
            arr.push(Number(this.popularData[i].count))
            // this.popularCount += Number(this.popularData[i].count)
          }
          this.popularCount = Math.max(...arr)
        }
      })
    },
    getEntranceData() {
      getEntrance().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.enterDataList = res.data.obj
        }
      })
    },
    getEachVenueCapacityData() {
      getEachVenueCapacity().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.allVenuesData = res.data.obj
          this.getAreasData()
          this.getVenueProfileData()
        }
      })
    },
    getAreasData() {
      getAreas(this.allVenuesData[this.currVenuesIndex].id).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getAreas:', res)
          this.tabsList = res.data.obj
          if (this.tabsList.length > 0) {
            this.getVenueOrderOpenData()
          } else {
            this.areaList = []
            this.tiemList = []
            this.tableData = []
          }
        }
      })
    },
    getVenueOrderOpenData() {
      let date = this.formatDate(this.orderDate)
      getVenueOrderOpen(this.tabsList[this.tabsIndex].areaId, date).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getVenueOrderOpenData:', res)
          this.areaList = res.data.obj.blocks
          this.tiemList = res.data.obj.times
          this.tableData = res.data.obj.list
        }
      })
    },
    getVenueProfileData() {
      getVenueProfile(this.allVenuesData[this.currVenuesIndex].id).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getVenueProfileData:', res)
          this.discrib = res.data.obj
        }
      })
    },
    formatDate(date) {
      var dateObj = new Date(date)
      var year = dateObj.getFullYear().toString()
      var month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      var day = dateObj.getDate().toString().padStart(2, '0')
      var formattedDate = `${year}-${month}-${day}`
      return formattedDate
    },
    //操作
    venueClick(item, index) {
      this.currVenuesIndex = index
      console.log('venueClick item:', item)
      this.tabsIndex = 0
      this.getAreasData()
      this.getVenueProfileData()

      console.log('scrollDiv:', this.myScrollDiv)
    },
    changeDate() {
      this.tabsIndex = 0
      this.getAreasData()
    },
    //进入场馆
    pageToEach(item) {
      console.log('pageToEach')
      this.$router.push({
        path: '/cockpit/eachvenues',
        query: {
          venues: item.id,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/venues.scss';

.jsc-bg {
  width: 100vw;
  //   min-width: 1200px;
  height: 100vh;
  //   min-height: 800px;
  overflow: hidden;
  //   background: #09120f;
  //   background: #09120f url('../../../assets/img/cockpit/home-bg.svg') no-repeat
  //     center;
  background: #09120f no-repeat center;
  color: #fff;
  user-select: none;

  .top {
    width: 100%;
    height: 5.208vw;
    background: url('../../../assets/img/cockpit/top.svg') no-repeat;
    background-size: 100%;
    position: relative;

    .sys-title {
      width: 100%;
      height: 100%;
      line-height: 5.208vw;
      vertical-align: middle;
      text-align: center;
      font-size: 1rem;
    }

    .sys-date,
    .sys-temp {
      font-size: 0.5rem;
      position: absolute;
    }

    .sys-date {
      line-height: 44px;
      top: calc(2.604vw - 18px);
      left: 6vw;
    }

    .sys-temp {
      top: calc(2.604vw - 22px);
      right: 6vw;
      display: flex;
      flex-direction: row-reverse;
    }
  }
}

.sys-temp ::v-deep .s-sticker-tmp {
  font-size: 0.5rem !important;
}

.sys-temp ::v-deep img {
  height: 0.7rem !important;
  width: 0.7rem !important;
}

.sys-temp ::v-deep #weather-view-he {
  display: none !important;
}
::-webkit-scrollbar {
  display: none;
}

.ml-16 {
  margin-left: 16px;
}
.mt-8 {
  margin-top: 8px;
}
.select-option ::v-deep .el-input__inner,
.el-select-dropdown__item.is-disabled:hover {
  background-color: rgba(255, 255, 255, 0.01) !important;
}
.select-option ::v-deep .el-input__inner {
  border: 1px solid #007a4d !important;
  height: 36px;
  color: #fff;
}
.select-option ::v-deep .el-input__icon {
  line-height: 36px;
}

.el-table {
  border-bottom: 1px solid #007a4d;
  border-right: 1px solid #007a4d;
  margin: e auto;
}
::v-deep.el-table th {
  border: 1px solid #007a4d !important;
  border-right: none !important;
  border-bottom: none !important;
}
::v-deep.el-table td {
  border: 1px solid #007a4d;
  border-right: none !important;
  border-bottom: none !important;
}
.order-table ::v-deep .el-table .el-table__cell {
  padding: 5px 0;
}
// .order-table ::v-deep .cell {
//   min-height: 44px;
// }
.only {
  height: 44px;
  line-height: 44px;
}
::-webkit-scrollbar {
  display: none;
}
.order-table ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  display: unset;
  width: 10px;
  height: 10px;
}

.order-table ::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f5f7fa; // 设置背景颜色
  border-radius: 10px;
}

.order-table ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px; // 设置滑块边角半径
  background-color: #339571; // 设置滑块颜色及透明度
}
.order-table ::v-deep .el-table__fixed {
  bottom: 10px !important;
}
.animated-top {
  transition: all 0.5s;
  margin-top: -30px;
}
</style>
